// Fast Fit -> subject guide context. Tab-scoped, no tokens or answers: only ids, family slugs and picked subject names.
const CTX = "wua.fastFit.guideCtx";
const draftKey = (snapId) => `wua.fastFit.picks.${snapId}`;

export const familySlug = (name) => String(name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

const read = (k) => { try { return JSON.parse(sessionStorage.getItem(k) || "null"); } catch (_e) { return null; } };
const write = (k, v) => { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (_e) { /* storage disabled */ } };

export const readGuideCtx = () => read(CTX);
export function saveGuideCtx({ sessionId, snapshotId, selected, family, pickable }) {
  write(CTX, { sessionId, snapshotId, selected: selected || [], origin: family, pickable: pickable || [], at: Date.now() });
}

// Current working selection for a result (what the results page shows, saved or not yet saved).
export const readDraft = (snapId) => {
  const d = snapId ? read(draftKey(snapId)) : null;
  return d && Array.isArray(d.names) ? d : null;
};
// basePlanAt = the saved plan's server updatedAt the draft was built on (no client clocks involved).
export const saveDraft = (snapId, names, basePlanAt = null) => snapId && write(draftKey(snapId), { names, basePlanAt });
// A tab draft wins only while the saved plan is the one it was built on (so another tab/device's save isn't shadowed).
export function workingNames(draft, plan) {
  if (draft && (!plan || draft.basePlanAt === plan.updatedAt)) return { names: draft.names, from: "draft" };
  return plan?.interests?.length ? { names: plan.interests, from: "plan" } : null;
}

export const FROM_PARAM = "from=fast-fit";
export const guideHref = (slug, family) => `/subjects/${slug}?${FROM_PARAM}&family=${encodeURIComponent(family)}`;
export const resultsHref = (family) => `/beta/course-fit${family ? `?ffFamily=${encodeURIComponent(family)}` : ""}`;

export function fastFitParams(search) {
  const q = new URLSearchParams(search || "");
  return q.get("from") === "fast-fit" ? { family: q.get("family") || null } : null;
}
